import { NavMarker } from 'react-rhumb';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function PDFError({
  onRetry,
  isPDFError
}) {
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    direction: "column",
    marginBlockStart: "300",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "DOCUMENT_NOT_FOUND"
    }), /*#__PURE__*/_jsx(Illustration, {
      name: "empty-state-records",
      width: 150,
      marginBlockEnd: "300"
    }), /*#__PURE__*/_jsx(Text, {
      as: "h2",
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pdf.error.errorTitle"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pdf.error.errorDescription"
      })
    }), isPDFError && /*#__PURE__*/_jsx(Button, {
      use: "primary",
      onClick: onRetry,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pdf.error.tryAgain"
      })
    })]
  });
}